import { gql } from '@apollo/client'

export const NEW_EXECUTION = gql`
  mutation NewExecution($event_id: String!, $show_id: String!) {
    newExecution(event_id: $event_id, show_id: $show_id) {
      execution_id
      show_data_id
    }
  }
`
